import BigNumber from 'bignumber.js'
import erc20 from 'config/abi/erc20.json'
import masterchefABI from 'config/abi/moonMaster.json'
import multicall from 'utils/multicall'
import { getAddress, getMoonMasterAddress } from 'utils/addressHelpers'
import { FarmConfig } from 'config/constants/types'

const fetchFarms = async (farmsToFetch: FarmConfig[]) => {
  const data = await Promise.all(
    farmsToFetch.map(async (farmConfig) => {
      const lpAddress = getAddress(farmConfig.lpAddresses)
      const calls = [
        // Balance of token in the LP contract
        {
          address: getAddress(farmConfig.token.address),
          name: 'balanceOf',
          params: [lpAddress],
        },
        // Balance of quote token on LP contract
        {
          address: getAddress(farmConfig.quoteToken.address),
          name: 'balanceOf',
          params: [lpAddress],
        },
        // Balance of LP tokens in the master chef contract
        {
          address: lpAddress,
          name: 'balanceOf',
          params: [getMoonMasterAddress()],
        },
        // Total supply of LP tokens
        {
          address: lpAddress,
          name: 'totalSupply',
        },
        // Token decimals
        {
          address: getAddress(farmConfig.token.address),
          name: 'decimals',
        },
        // Quote token decimals
        {
          address: getAddress(farmConfig.quoteToken.address),
          name: 'decimals',
        },
      ]
      
      const [
        tokenBalanceLP,
        quoteTokenBalanceLP,
        lpTokenBalanceMC,
        lpTotalSupply,
        tokenDecimals,
        quoteTokenDecimals,
      ] = await multicall(erc20, calls)
      // console.log(tokenBalanceLP.toString(),
      //   quoteTokenBalanceLP.toString(),
      //   lpTokenBalanceMC.toString(),
      //   lpTotalSupply.toString(),
      //   tokenDecimals.toString(),
      //   quoteTokenDecimals.toString())

      // Ratio in % a LP tokens that are in staking, vs the total number in circulation
      // const lpTokenBalanceMCTest = new BigNumber(10000000000)
      // console.log(`pid: ${farmConfig.pid} lpTokenBalanceMC: ${lpTokenBalanceMC.toString()}`)
      // console.log(`pid: ${farmConfig.pid} lpTotalSupply: ${lpTotalSupply.toString()}`)
      const lpTokenRatio = new BigNumber(lpTokenBalanceMC).div(new BigNumber(lpTotalSupply))
      // console.log(`pid: ${farmConfig.pid} lpTokenRatio: ${lpTokenRatio.toString()}`)
      // Total value in staking in quote token value
      const lpTotalInQuoteToken = new BigNumber(quoteTokenBalanceLP)
        .div(new BigNumber(10).pow(farmConfig.quoteToken.decimals))
        .times(new BigNumber(2))
        .times(lpTokenRatio)

      // Amount of token in the LP that are considered staking (i.e amount of token * lp ratio)
      const tokenAmount = new BigNumber(tokenBalanceLP).div(new BigNumber(10).pow(tokenDecimals)).times(lpTokenRatio)
      const quoteTokenAmount = new BigNumber(quoteTokenBalanceLP)
        .div(new BigNumber(10).pow(quoteTokenDecimals))
        .times(lpTokenRatio)
      // console.log(`pid: ${farmConfig.pid} tokenAmount: ${tokenAmount.toString()}`)
      // console.log(`pid: ${farmConfig.pid} quoteTokenAmount: ${quoteTokenAmount.toString()}`)

      const [info, totalAllocPoint] = await multicall(masterchefABI, [
        {
          address: getMoonMasterAddress(),
          name: 'poolInfo',
          params: [farmConfig.pid],
        },
        {
          address: getMoonMasterAddress(),
          name: 'totalAllocPoint',
        },
      ])
      
      const allocPoint = new BigNumber(info.allocPoint._hex)
      const poolWeight = allocPoint.div(new BigNumber(totalAllocPoint))

      return {
        ...farmConfig,
        tokenAmount: tokenAmount.toJSON(),
        quoteTokenAmount: quoteTokenAmount.toJSON(),
        lpTotalSupply: new BigNumber(lpTotalSupply).toJSON(),
        lpTotalInQuoteToken: lpTotalInQuoteToken.toJSON(),
        tokenPriceVsQuote: quoteTokenAmount.div(tokenAmount).toJSON(),
        poolWeight: poolWeight.toJSON(),
        multiplier: `${allocPoint.div(100).toString()}X`,
      }
    }),
  )
  return data
}

export default fetchFarms
